import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HeaderComponent } from './ui/main-layout-components/header/header.component';
import { FooterComponent } from './ui/main-layout-components/footer/footer.component';
import { MainComponent } from './ui/main-layout-components/main/main.component';
import { DynamicComponentLoaderModule } from './shared/dynamic-component-loader/dynamic-component-loader.module';
import { dynamicComponents } from './ui/dynamic-component-manifest';
import { TopLevelNavigationComponent } from './ui/main-layout-components/top-level-navigation/top-level-navigation.component';
import { ScrollTopComponent } from './ui/main-layout-components/scroll-top/scroll-top.component';
import { components } from './project-specific-component';
import { SharedModule } from './shared/shared.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslationsLoader } from './service/translations-loader';
import { AppErrorHandler } from './app-error-handler';
import { AUTOSUGGEST_CONFIG } from './dynamic-module/lib/panel/autosuggest-panel/config';
import { config } from './app.config';
import { Link2Module } from './dynamic-module/lib/ui-kit/link2/link2.module';
import { SubscribePanelModule } from './dynamic-module/lib/panel/subscribe-panel/subscribe-panel.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DynamicPageLoaderComponent } from './shared/dynamic-page-loader/dynamic-page-loader.component';
import { HomeModule } from './ui/pages/home/home.module';
import { ContentModule } from './ui/pages/content/content.module';
import { NotFoundModule } from './ui/pages/not-found/not-found.module';
import { SearchResultModule } from './ui/pages/search-result/search-result.module';
import { NewsOverviewModule } from './ui/pages/news-overview/news-overview.module';
import { NewsDetailsModule } from './ui/pages/news-details/news-details.module';
import { LoginModule } from './ui/pages/login/login.module';
import { DynamicModule } from './shared/components/dynamic/dynamic.module';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MainComponent,
    TopLevelNavigationComponent,
    ScrollTopComponent,
    DynamicPageLoaderComponent,
    ...components,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    DynamicComponentLoaderModule.forRoot(dynamicComponents),
    SharedModule,
    DynamicModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationsLoader,
        deps: [HttpClient]
      }
    }),
    BrowserAnimationsModule,
    Link2Module,
    SubscribePanelModule,
    HomeModule,
    ContentModule,
    NotFoundModule,
    SearchResultModule,
    NewsOverviewModule,
    NewsDetailsModule,
    LoginModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler
    },
    {
      provide: AUTOSUGGEST_CONFIG,
      useValue: {endPoint: config.autoSuggestApi, page: 0, searchPageUrl: 'search-result-page'}
    },
    { provide: 'Window',  useValue: window }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
